import Skeleton from "./Skeleton";
import SkeletonTextLine from "./SkeletonTextLine";

/**
 * Cold-boot silhouette of the auth funnel pages (/welcome, /login, /signup).
 * Bottom-anchored column: logo, large title (2 lines), subtitle, two
 * full-width CTA buttons, legal caption. Top ~60% is empty (the welcome
 * page's feed wall area). Self-contained — no queries, no auth reads.
 */
export default function AuthBootSkeleton(): React.JSX.Element {
  return (
    <div className="flex size-full flex-col justify-end overflow-hidden bg-white md:mx-auto md:max-w-lg">
      <div className="flex flex-col gap-3 px-6 pb-24">
        {/* Logo (h-12, left-aligned). */}
        <Skeleton className="rounded-xl" width={140} height={48} />

        {/* Title (2 lines, text-welcome-title ~28/36). */}
        <div className="flex flex-col gap-1">
          <SkeletonTextLine width="85%" fontSize={28} lineHeight={36} />
          <SkeletonTextLine width="60%" fontSize={28} lineHeight={36} />
        </div>

        {/* Subtitle (1 line, text-heading-xs ~14/20). */}
        <SkeletonTextLine width="70%" fontSize={14} lineHeight={20} />

        {/* CTA buttons (2 × full-width, size lg ~48px). */}
        <div className="flex flex-col gap-2 pt-3">
          <Skeleton className="rounded-xl" width="100%" height={48} />
          <Skeleton className="rounded-xl" width="100%" height={48} />
        </div>

        {/* Legal caption (centered, text-caption ~11/16). */}
        <div className="flex justify-center pt-2">
          <SkeletonTextLine width="80%" fontSize={11} lineHeight={16} />
        </div>
      </div>
    </div>
  );
}
